//project pictures
import flickthedeck from "../img/flick-the-deck.png";
import weather from "../img/weather.png";
import quiz from "../img/mainscreenquiz.png";
import empgen from "../img/employeegen.png";
import burger from "../img/brown burger.png";
import cleanhackers from "../img/cleanhackers.png";
import ConnectChore from "../img/connectchore.png";

const ProjectData = [
    {
        img: flickthedeck,
        code: "https://github.com/ARam2142/Flick-the-Deck",
        title: "Flick the Deck",
        site: "https://mwoodervin.github.io/Flick-the-Deck/",
        description: "This application will give the user the option to pick a movie of their choice. If you're not satisfied with the option given, shuffle the deck and pick again.",
        technologies: 'Made with HTML, CSS, Materialize, Javascript and jQuery.'
    },
    {
        img: weather,
        code: "https://github.com/ARam2142/Weather-DashBoard",
        title: "Weather-Dashboard",
        site: "https://aram2142.github.io/Weather-DashBoard/",
        description: "The Weather Dashboard provides the current weather and 5 day forcast where ever you are in the world.",
        technologies: 'Made with HTML, CSS, Bootstrap, Javascript, jQuery, and Openweather API.'
    },
    {
        img: quiz,
        code: "https://github.com/ARam2142/Javascript-Code-Quiz",
        title: "Code Quiz",
        site: "https://aram2142.github.io/Javascript-Code-Quiz/",
        description: "This mock Quiz application features 5 questions about Javascript. It is designed to test your knowledge.",
        technologies: 'Made with HTML, CSS, Bootstrap, and Javascript.'
    },
    {
        img: empgen,
        code: "https://github.com/ARam2142/Employee-Summary/blob/master/app.js",
        title: "Employee Profile Generator",
        site: "https://github.com/ARam2142/Employee-Summary",
        description: "The Employee Profile Generator is an app that will dynamically create a software engineering team.",
        technologies: 'Made with HTML, CSS, Javascript, Node.js, Bootstrap, npm inquirer.'
    },
    {
        img: burger,
        code: 'https://github.com/ARam2142/Eat-Da-Burger-Node-Handlebars-Application',
        title: "Eat-Da-Burger",
        site: "https://cryptic-shelf-77263.herokuapp.com/",
        description: "Eat-Da-Burger is a mock restaruant menu where users make their own burgers and eat them for dinner.",
        technologies: 'Made with HTML, CSS, Javascript, jQuery, Node Express, Express-Handlebars and MySql.'
    },
    {
        img: cleanhackers,
        code: "https://github.com/dylanbest15/Outdoor-Adventure-Buddies",
        title: "Outdoor Adventure Buddies",
        site: "https://whispering-castle-57159.herokuapp.com/",
        description: "Outdoor Adventure Buddies is a mock travel app that allows users to find friends anywhere in the world.",
        technologies: 'Made with HTML, CSS, Javascript, Bootstrap, Node.js, Express.js, Sequelize, Express-Handlebars, and nodemon.'
    },
    {
        img: ConnectChore,
        code: "https://github.com/ARam2142/ConnectChore",
        title: 'ConnectChore',
        site: 'https://connectchore.herokuapp.com',
        description: 'ConnectChore is an app that provides incentives to kids (and adults) for getting chores done by pairing task lists with rewards and includes an integrated game for family members to compete for special prizes.',
        technologies: 'HTML, CSS, Javascript, React, Redux, Mongoose, Express.js, Nodemon, React-Bootstrap, and MongoDB Atlas.'
    },


];

export default ProjectData;